/* Shopify resolves translated resource handles through its localization endpoint. */
(() => {
  document.addEventListener('submit', event => {
    if (!event.target.matches('.header-language-form')) return;
    const returnTo = event.target.querySelector('[name="return_to"]');
    if (returnTo) returnTo.value = location.pathname + location.search + location.hash;
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-header-language][open]').forEach(selector => {
      if (!selector.contains(event.target)) selector.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-header-language][open]').forEach(selector => {
      selector.open = false;
      selector.querySelector('summary').focus();
    });
  });
})();
